export default __webpack_public_path__ + "static/media/Cover.574813b0.png";